import type { PayloadAction } from '@reduxjs/toolkit';
import type { EditorState } from './state';
import type { BlockOption } from './types/blocks';

/**
 * Задание stylepack/option-grid, коммит 2 — тело действия
 * `setBlockOptionIcon`: значок ОДНОГО варианта ответа (эмодзи символом или
 * своя картинка). Своим действием, а не через `updateBlockOption`: тот пишет
 * ТЕКСТ варианта (label обязателен), и подмешивать туда настройку значило бы
 * делать текст необязательным у всех его вызывающих (довод WEB-1810 у
 * `setBlockOptionNextScreen`).
 *
 * `undefined` снимает КЛЮЧ, а не оставляет его со значением undefined
 * (WEB-955): иначе вариант без значка не равен варианту, которого правка не
 * касалась. Состав списка не меняется.
 *
 * Живёт здесь, а не в editorSlice.ts: фасад держит храповик длины (WEB-2552).
 * Создатель действия и регистрация — `./screenFieldActions.ts`, имя
 * `editor/setBlockOptionIcon`.
 */
export interface BlockOptionIconPayload {
  screenId: string;
  blockId: string;
  optionId: string;
  icon?: BlockOption['icon'];
}

export function setBlockOptionIconReducer(
  state: EditorState,
  action: PayloadAction<BlockOptionIconPayload>,
): EditorState {
  const { screenId, blockId, optionId, icon } = action.payload;
  let touched = false;
  const content = state.content.map((s) =>
    s.id !== screenId
      ? s
      : {
          ...s,
          blocks: s.blocks.map((b) =>
            b.id !== blockId
              ? b
              : {
                  ...b,
                  options: (b.options ?? []).map((o) => {
                    if (o.id !== optionId) return o;
                    touched = true;
                    if (icon === undefined) {
                      const { icon: _dropped, ...rest } = o;
                      return rest;
                    }
                    return { ...o, icon };
                  }),
                },
          ),
        },
  );
  return touched ? { ...state, content, isDirty: true } : state;
}
